import { useState } from "react";

const ExternalLink = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

const STATUS_INFO = [
  { label: "Under Process", color: "#b45309", bg: "#fef3c7", desc: "BPC is working on your application" },
  { label: "Approved", color: "#15803d", bg: "#dcfce7", desc: "Service delivered — download your ticket" },
  { label: "Rejected", color: "#b91c1c", bg: "#fee2e2", desc: "Application rejected — download for details" },
];

export default function TicketRedirectCard({ ticketUrl }) {
  return (
    <div style={{
      background: "var(--color-background-primary)",
      border: "0.5px solid var(--color-border-tertiary)",
      borderRadius: "var(--border-radius-lg)",
      borderTop: "3px solid #1d4ed8",
      padding: "14px 16px 16px",
      marginTop: "8px",
      maxWidth: "440px",
      fontFamily: "var(--font-sans)",
    }}>

      {/* Badge */}
      <span style={{ fontSize: "10px", fontWeight: "500", letterSpacing: "0.06em", textTransform: "uppercase", color: "#1d4ed8", background: "#dbeafe", padding: "2px 8px", borderRadius: "4px", display: "inline-block", marginBottom: "8px" }}>
        My Applications
      </span>

      {/* Title */}
      <h3 style={{ margin: "0 0 5px", fontSize: "15px", fontWeight: "500", color: "var(--color-text-primary)", lineHeight: 1.3 }}>
        Track your application
      </h3>
      <p style={{ margin: "0 0 12px", fontSize: "13px", color: "var(--color-text-secondary)", lineHeight: 1.55 }}>
        View all your submitted applications, check their current status, and download tickets from the OSR portal.
      </p>

      {/* Status legend */}
      <div style={{ background: "var(--color-background-secondary)", border: "0.5px solid var(--color-border-tertiary)", borderRadius: "var(--border-radius-md)", padding: "10px 12px", marginBottom: "12px" }}>
        <p style={{ margin: "0 0 8px", fontSize: "11px", fontWeight: "500", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--color-text-secondary)" }}>
          Application statuses
        </p>
        {STATUS_INFO.map(({ label, color, bg, desc }) => (
          <div key={label} style={{ display: "flex", alignItems: "center", gap: "8px", padding: "4px 0", borderBottom: "0.5px solid var(--color-border-tertiary)" }}>
            <span style={{ fontSize: "11px", fontWeight: "500", color, background: bg, padding: "1px 7px", borderRadius: "3px", minWidth: "90px", textAlign: "center" }}>
              {label}
            </span>
            <span style={{ fontSize: "12px", color: "var(--color-text-secondary)" }}>{desc}</span>
          </div>
        ))}
      </div>

      {/* Steps */}
      <div style={{ marginBottom: "14px" }}>
        <p style={{ margin: "0 0 8px", fontSize: "11px", fontWeight: "500", textTransform: "uppercase", letterSpacing: "0.05em", color: "var(--color-text-secondary)" }}>
          How to find your application
        </p>
        {[
          "Log in to the OSR portal",
          "Click 'View Application' in the top menu",
          "Enter your Application ID or click 'View All'",
          "Download your ticket if status is Approved or Rejected",
        ].map((step, i) => (
          <div key={i} style={{ display: "flex", gap: "8px", alignItems: "flex-start", marginBottom: "6px" }}>
            <span style={{ minWidth: "18px", height: "18px", background: "#1d4ed8", color: "#fff", borderRadius: "50%", fontSize: "10px", fontWeight: "500", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "1px" }}>
              {i + 1}
            </span>
            <span style={{ fontSize: "12px", color: "var(--color-text-secondary)", lineHeight: 1.45 }}>{step}</span>
          </div>
        ))}
      </div>

      {/* Button */}
      <a
        href={ticketUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", padding: "9px 0", background: "#1d4ed8", color: "#fff", borderRadius: "var(--border-radius-md)", fontSize: "13px", fontWeight: "500", textDecoration: "none" }}
      >
        View my applications <ExternalLink />
      </a>

    </div>
  );
}